import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import router from '../../versa/router.js';
import { notify, ask } from '../../versa/msgbox.js';
import view from '../views/programs.js';
import form from '../forms/programs.js';
import * as types from '../types.js';

const programs = function()
{
	let programs_crud = crud.create({
		async deleteProgram() {
			const ids = await this.getSelectedIds(['company_id', 'id']);
			if (!ids.length) return notify('Selecione ao menos um programa.', 'Programas');
			ask(`Excluir ${ids.length} programa(s)? Só é possível excluir programas sem registros vinculados (produtos, lotes, pedidos, entradas).`, 'Excluir', async (answer) => {
				if (answer !== 'Y') return;
				for (const [company_id, id] of ids) {
					const resp = await api.call(api.delete_program, company_id, id);
					if (resp === undefined) return;
				}
				this.reloadPage();
			});
		},
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(error => notify(error)));
		},
		async queryData(query)
		{
			return await api.call(api.list_programs, query);
		},
		async loadRecord(id)
		{
			return await api.call(api.select_program, ...JSON.parse(id));
		},
		async saveRecord(data, old_data)
		{
			let _record = {
				name: String(data.name || '').trim(),
				code: (data.code && data.code.trim()) ? data.code.trim() : null,
				is_default: !!data.is_default,
			};
			if (old_data)
				return await api.call(api.update_program, data.company_id, data.id, _record);
			else
				return await api.call(api.insert_program, data.company_id, _record);
		},
	});

	let fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'id', label: 'Programa', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador do programa' },
		{ index: 3, field: 'name', label: 'Nome', types: [], placeholder: '', title: 'Nome do programa' },
		{ index: 4, field: 'code', label: 'Código', types: [], placeholder: 'PADRAO', title: 'Código (opcional)' },
		{ index: 5, field: 'is_default', label: 'Padrão', types: [types.checkbox()], placeholder: '', title: 'Programa padrão da empresa' },
	];

	let operations = [
		{ hash: '#program-delete', label: 'Excluir' },
	];
	router.set('#program-delete', programs_crud.deleteProgram.bind(programs_crud));
	document.addEventListener('programs:reload', () => programs_crud.reloadPage());

	programs_crud.run(
		'programs',
		'Programas',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs,
		operations
	);
};

export default programs;
